import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

const KEY = 'latest_transaction_id';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function getTransactionIdFromStore() {
  try {
    const infoJson = _getStore().getItem(KEY);
    if (infoJson == null) return null;
    return JSON.parse(infoJson);
  } catch (error) {
    console.log(error);
    return null;
  }
}

function updateTransactionIdInStore(transactionId) {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify(transactionId));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class LatestTransactionIdContainer extends Container {
  constructor() {
    super();
    this.state = {
      transactionId: getTransactionIdFromStore()
    };
    window.addEventListener('storage', e => {
      if (e.key !== KEY) return;
      this.setState({ transactionId: getTransactionIdFromStore() });
    });
  }

  get() { return this.state.transactionId; }

  set(transactionId) {
    return new Promise((resolve, reject) => {
      updateTransactionIdInStore(transactionId)
        .catch(console.log)
        .finally(() => this.setState({ transactionId: transactionId }, resolve));
    });
  }
}

export default LatestTransactionIdContainer;
